export var DisplayType;
(function (DisplayType) {
    DisplayType["grid"] = "grid";
    DisplayType["doublegrid"] = "doublegrid";
    DisplayType["map"] = "map";
})(DisplayType || (DisplayType = {}));
//# sourceMappingURL=displayType.js.mapexport var DisplayType;
(function (DisplayType) {
    DisplayType["grid"] = "grid";
    DisplayType["doublegrid"] = "doublegrid";
    DisplayType["map"] = "map";
})(DisplayType || (DisplayType = {}));
//# sourceMappingURL=displayType.js.map